// JQ4-29 — US-TICKETS-009: Supervisor real-time operations dashboard contracts.
// Single source of truth for backend serialization and frontend deserialization.
//
// NOTE: valetEmail is the valet's email address. User.displayName does NOT exist in the schema.
// The UI renders email as-is or "Unassigned" when null.
import { z } from 'zod';
// ── Active ticket row ─────────────────────────────────────────────────────────
export const supervisorActiveTicketSchema = z.object({
    id: z.string(),
    ticketNumber: z.number().int().positive(),
    status: z.enum(['parked', 'requested', 'in_transit']),
    plate: z.string(),
    parkingZone: z.string().nullable(),
    /** Valet email — null when no valet is assigned. NOT a displayName (does not exist). */
    valetEmail: z.string().nullable(),
    /** ISO UTC timestamp: when the ticket was created / checked in. */
    checkedInAt: z.string(),
    /** ISO UTC timestamp: when the retrieval was requested. Null for parked tickets. */
    retrievalRequestedAt: z.string().nullable(),
    /**
     * ISO UTC timestamp: when a valet claimed the retrieval.
     * Null for parked and requested tickets.
     * Used by the frontend as the elapsed anchor for in_transit tickets (design D5).
     */
    claimedAt: z.string().nullable(),
});
export const supervisorActiveTicketsResponseSchema = z.object({
    items: z.array(supervisorActiveTicketSchema),
});
// ── Shift metrics ─────────────────────────────────────────────────────────────
export const supervisorShiftMetricsSchema = z.object({
    /** Count of tickets checked in (checkedInAt) today at this location. */
    checkInsToday: z.number().int().min(0),
    /** Count of active tickets (parked | requested | in_transit) right now. */
    activeNow: z.number().int().min(0),
    /** Count of tickets with status=requested right now. */
    pendingRetrieval: z.number().int().min(0),
    /** Count of tickets delivered (deliveredAt) today at this location. */
    deliveriesToday: z.number().int().min(0),
    /**
     * Rounded mean of retrievalDurationSeconds for delivered tickets today.
     * 0 when no delivered tickets exist (never NaN or null).
     */
    avgRetrievalSeconds: z.number().int().min(0),
    /**
     * Distinct count of valets currently mid-retrieval (in_transit right now).
     * Label: "Valets retrieving" — NOT "Active valets" (design D4).
     * A valet idle between jobs does NOT count (no shift/roster concept).
     */
    activeValets: z.number().int().min(0),
});
//# sourceMappingURL=supervisor-dashboard-schemas.js.map